module.exports = __webpack_public_path__ + "static/img/m_faq_articles_time@3x.11d0f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_faq_articles_time@3x.png
// module id = BF9h
// module chunks = 1